<template>
  <div>
    <v-row>
      <v-col cols="12" md="4" class="mt-2 d-flex gap-10px">
        <v-select dense label="Docente" :style="{ width: '100%'}" :items="listDocente" v-model="id_personal"
          item-text="apellido_nombre" item-value="id" @change="cargaDocenteRenderizado()" :return-object="true"
          :rowHeight="20"></v-select>
      </v-col>
    </v-row>
    <v-row>
 
      <v-col class="d-flex justify-end">
      <v-btn style="width: 180px;" color="success" @click="generarExcel" class="mx-2">
        'Generar Excel'
        <v-icon right small>fa-file-excel</v-icon>
      </v-btn>
    </v-col>
    </v-row>

    <v-row class="fill-height">
      <v-col class="d-flex justify-center align-center">
        <ag-grid-vue v-if="rowData.length > 0" class="ag-theme-balham" :style="{ width: '80%', height: '40vh' }"
          :columnDefs="columnDefs" :rowData="rowData">
        </ag-grid-vue>
        <v-card v-else class="d-flex justify-center align-center" style="height: 100px; width: 300px;">
          <span>El docente no tiene cursos asignados</span>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script> 
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";


export default {
    name:'cargadocente',
    components: {
     AgGridVue,

  },
    data:() => ({
       listDocente:[],
       id_colegio: sessionStorage.id_colegio,
       id_ano_lectivo: sessionStorage.id_ano_lectivo,
       diasHabiles: [],
       diasSemanas: [],
       diasSeleccionados: [],
       columnDefs:[],
       rowData:[],
       id_persona:"",
       id_personal:""
   
    }),
    mounted() {
        this.allDocentes();
       // this.getDiasHabiles();
        this.getDiasDeLaSemana();
        this.cargarDatosYObtenerDiasHabiles();
    },
    methods: {
      // Mensajes de sistema

      ...mapMutations("mensajeSis", ["setEnviarMens"]),

        async allDocentes() {
     
      try {
        let response = await axios.get( `/horario/cargaDocente/${this.id_colegio}`);
         this.listDocente = response.data;
      }catch (e) {
        console.log(e);
  
            }   
        },

        async getDiasHabiles() {
      let id_colegio = sessionStorage.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
        console.log("diasHabiles", this.diasHabiles);
      } catch (error) {
        // console.log(error);
      }
    },
    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
        console.log("diasSemanas", this.diasSemanas);
      } catch (e) {
        console.log(e);
      }
    },

    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.all([this.getDiasHabiles(), this.getDiasDeLaSemana()]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    },

    obtenerNombresDiasHabiles() {
      if (!this.diasHabiles || !this.diasSemanas) {
        return [];
      }

      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => diaHabil.nombre_dia);
      return this.nombresDiasHabiles;
    },

    // metodo para actualizar las columnas del horario

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }

      // Columna fija para el horario
      const columnasDinamicas = [
        { field: "hora", headerName: "Hora", pinned: "left", width: 100 },
      ];

      // Y luego para los días hábiles:
      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas.push({
          headerName: dia,
          field: dia.toLowerCase(),
          width: 150,
          flex: 3 
        });
      });

      // Luego establece las columnDefs actualizadas y refresca el grid
      this.columnDefs = columnasDinamicas;
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async cargaDocenteRenderizado(selectedDocente) {
      console.log("id_personal", this.id_personal)
     // this.id_persona = this.id_personal.id_persona;

          const data1 = {
            id_ano_lectivo:this.id_ano_lectivo,
            id_colegio:this.id_colegio,
            id_personales: this.id_personal.id
          };
        console.log("data1", data1);
          const response = await axios.post(
            `/administrativo/asignacionDocenteCurso/cargaDocente`,
            data1
          );
          console.log("respones",response);

          const formattedData = response.data.data.map(item => {
            const [horaInicio, horaFin] = item.hora.split(" - ").map(h => h.substring(0, 5));
            return {
              hora: `${horaInicio} - ${horaFin}`,
              lunes: item.lunes,
              martes: item.martes,
              miércoles: item.miercoles,  
              jueves: item.jueves,
              viernes: item.viernes,
              sábado: item.sabado,
              domingo: item.domingo,
              id:item.id_personal,
            };
          });

          this.rowData = formattedData; 
    },

    async generarExcel(){
       try {
        
        let archivoADescargar = "";
        this.data2 = {
          anioLectivo:parseInt(this.id_ano_lectivo),
          colegio: parseInt(this.id_colegio),
          id_persona: parseInt(this.id_personal.id_persona),
          codigoReporte: "horario_docente",
          tamanioPorHoja: 50,
          BUCKET_ORIGIN_SPACE: this.URL_SPACE
        }
        
        let response = await axios.post(
          'academico/progDocente/excelhorariodocente',
            this.data2
        );
        
        let dataResponse = response.data;
         console.log("responder",dataResponse)
        this.setEnviarMens({
          tipo: dataResponse.messageT,
          mensaje: dataResponse.message,
          tiempo: 3000,
        });
        this.generandoReporte = 0;
        if (dataResponse.messageT == "S") {
          archivoADescargar = dataResponse.fileToDownload;
          axios({
            url:
              "/reporte/formatoReporte/bajarReporte/" + dataResponse.nameReport,
            method: "GET",
            responseType: "blob", // important
          }).then((response) => {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "¡Descargando reporte!",
              tiempo: 3000,
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", archivoADescargar);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          });
        }
       }catch(error){
        console.log(error)
       }
    }
    // onGridReady(params) {
    //   this.gridApi = params.api;
    //   this.gridColumnApi = params.columnApi;
    // },
    }
}

</script>
<style scoped>
  .v-col {
  width: 60%; 
  padding: 0;   
}
</style>